<div fxLayout="column">
    <div *ngIf="generalError" class="mat-error">
      {{generalError.message}}
    </div>
  
    <mat-chip-listbox>
      <ng-container *ngFor="let tester of selectedTesters">
        <mat-chip-option (click)="removeChip(tester)">
          {{tester.firstName}} {{tester.lastName}} {{tester.email}}
          <mat-icon class="mat-chip-remove">cancel</mat-icon>
        </mat-chip-option>
      </ng-container>
    </mat-chip-listbox>
    <mat-form-field>
      <mat-label>Testers</mat-label>
      <input matInput #in [matAutocomplete]="auto" [(ngModel)]="inputString" (ngModelChange)="showFilteredData()"
        cdkFocusInitial autofocus>
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
        (optionSelected)="onOptionClicked($event.option.value)">
        <mat-option *ngFor="let tester of filteredTesters" [value]="tester">
          <div class="researcher-info">
            <div class="name-surname">
              {{tester?.firstName}} {{tester?.lastName}}
            </div>
            <div class="email">
              {{tester?.email}}
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>
      <span *ngIf="loadingTesters" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <mat-hint *ngIf="!loadingTesters && filteredTesters.length === 0" class="color-warn">
        No testers available.
      </mat-hint>
    </mat-form-field>
  
  
    <div fxLayout="row" fxLayoutAlign="end">
      <button (click)="testbed = _testbed; canceled.emit()" mat-button>Cancel</button>
      <button (click)="addTesters()" [disabled]="selectedTesters.length === 0 || saving" color="primary"
        mat-button>
        <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
        <ng-container *ngIf="!saving">Save</ng-container>
      </button>
    </div>
  
  </div>
